module.exports = __webpack_public_path__ + "static/media/molinera_mayran.97a634b8.png";